import React from "react";
import "./Footer.style.css";
import { CgFacebook, CgInstagram } from "react-icons/cg";
import { MdKeyboardArrowRight } from "react-icons/md";

const Footer = () => {
  const facebookLink =
    window.innerWidth <= 992
      ? "fb://facewebmodal/f?href=https://m.facebook.com/100015893477841/"
      : "https://www.facebook.com/SamskrithiGoshala";

  return (
    <footer className="fade-up">
      <div className="footer">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="social_link">
                <span></span>
                <div className="icon_box">
                  <a href={facebookLink} target="_blank">
                    <CgFacebook />
                  </a>
                </div>
                <div className="icon_box">
                  <a
                    target="_blank"
                    href="https://www.instagram.com/amit.agarwal.1426"
                  >
                    <CgInstagram />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="important_link">
                <span>
                  <MdKeyboardArrowRight />
                  <a href="#about">about</a>
                </span>
                <span>
                  <MdKeyboardArrowRight />
                  <a href="#services">service</a>
                </span>
                <span>
                  <MdKeyboardArrowRight />
                  <a href="#engage">engage</a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="footer_text">
              <p className="pt-1 pb-1 mb-0 text-center">
                © Copyright <span> Samskriti Goshala </span>. All Rights
                Reserved
              </p>
              <p>
                Designed by
                <a href="https://koyosoftware.web.app/" target="_blank">
                  <span> Koyo Software Solutions</span>
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
